import { Abyss } from '@uhg-abyss/web/tools/types';
import { Box } from '@uhg-abyss/web/ui/Box';
import React from 'react';

import { ContentWrapper, PSXHeaderContentWrapper } from '../ContentWrapper';

interface Props {
  backgroundColor?: string;
  height?: string;
  children: React.ReactNode;
  // eslint-disable react/no-unused-prop-types
  showSearchInputBackButton?: boolean;
  id?: string;
  isWidget?: boolean;
  role?: string;
  showHeaderStyleforMap?: boolean;
  style?: Abyss.CSSProperties;
}

export const CardWrapper = ({
  backgroundColor = 'white',
  height = 'auto',
  children,
  isWidget,
  style,
}: Props) => (
  <Box
    color={backgroundColor}
    css={{
      'abyss-box-root': {
        padding: '0',
        height,
      },
    }}
    data-testid="card-wrapper"
  >
    <ContentWrapper isWidget={isWidget} style={style}>
      {children}
    </ContentWrapper>
  </Box>
);

export const PSXHeaderCardWrapper = ({
  backgroundColor = 'white',
  height = 'auto',
  showSearchInputBackButton,
  children,
  showHeaderStyleforMap,
}: Props) => (
  <Box
    color={backgroundColor}
    css={{
      'abyss-box-root': {
        '@media (max-width: 744px)': {
          borderBottom: 'solid',
          borderColor: '$headerCardWrapperBorderColor',
        },
        padding: '0',
        height,
      },
    }}
  >
    <PSXHeaderContentWrapper
      showHeaderStyleforMap={showHeaderStyleforMap}
      showSearchInputBackButton={showSearchInputBackButton}
    >
      {children}
    </PSXHeaderContentWrapper>
  </Box>
);

export const CardWrapperDetailsPage = ({
  backgroundColor = 'white',
  height = 'auto',
  children,
  id,
  role,
}: Props) => (
  <Box
    color={backgroundColor}
    css={{
      'abyss-box-root': {
        height,
        padding: '0px',
      },
    }}
    id={id}
    role={role}
  >
    {children}
  </Box>
);
